export default {
  404: "404",
  register: "S'inscrire",
  login: "Connexion",
  profit: "Profit",
  payout: "Paiement cible",
  btnDouble: "2×",
  wagered: "Misé",
  deposit: "Dépôt",
  inputFieldBtnMax: "Max",
  bets: "Paris",
  topHeaderAmount: "Montant",
  resetPasswordTitle: "Réinitialiser le mot de passe",
  resetPasswordNewPasswordTitle: "Nouveau mot de passe",
  resetPasswordNewPasswordErrorsRequired: "Le mot de passe est requis.",
  resetPasswordNewPasswordErrorsMinLength: "Minimum 8 caractères requis.",
  resetPasswordNewPasswordErrorsMaxLength: "Maximum 16 caractères autorisés.",
  resetPasswordNewPasswordErrorsPattern:
    "Doit contenir entre 8 et 16 caractères, incluant des lettres majuscules et minuscules, des chiffres et un caractère spécial (ex. : NextGen@123)",
  resetPasswordConfirmPasswordTitle: "Confirmer le mot de passe",
  resetPasswordConfirmPasswordErrorsNotMatched:
    "Les mots de passe ne correspondent pas.",
  resetPasswordResetBtn: "Réinitialiser",
  passwordResetSuccess: "Mot de passe modifié",
  resetPasswordWentWrong: "Une erreur est survenue !",
  partners: "Partenaires",
  submit: "Soumettre",
  signinUsername: "Email / Nom d'utilisateur",
  signinForgetPassword: "Mot de passe oublié ?",
  signinErrorsUserNameRequired: "Veuillez entrer un nom d'utilisateur/email.",
  signinErrorsPasswordRequired: "Le mot de passe est requis.",
  signinErrorsPasswordMinLength: "Minimum 8 caractères requis.",
  signinErrorsPasswordMaxLength: "Maximum 16 caractères autorisés.",
  signinTryAgain: "Une erreur est survenue ! Veuillez réessayer.",
  signinResetPasswordUsernameErr:
    "Veuillez entrer un nom d'utilisateur/email pour réinitialiser le mot de passe.",
  signinResetMailSentSuccessContent:
    "Nous vous avons envoyé un lien de réinitialisation de mot de passe par email. Veuillez vérifier votre email et réinitialiser votre mot de passe.",
  signupTitle: "S'inscrire",
  signupUsername: "Nom d'utilisateur",
  signupEmail: "Email",
  signupWalletConnect: "Connexion avec portefeuille",
  signupPassword: "Mot de passe",
  signupErrorsUserNameRequired: "Veuillez entrer un nom d'utilisateur.",
  signupErrorsFirstNameRequired: "Veuillez entrer un prénom.",
  signupErrorsLastNameRequired: "Veuillez entrer un nom de famille.",
  signupErrorsUserNameMinLength:
    "Minimum {{minimumCharacters}} caractères requis.",
  signupErrorsUserNameMaxLength:
    "Maximum {{maximumCharacters}} caractères autorisés.",
  signupErrorsUserNamePattern:
    "Veuillez entrer uniquement des lettres et des chiffres.",
  signupErrorsStringPattern: "Veuillez entrer uniquement des lettres.",
  signupErrorsEmailRequired: "Veuillez entrer un email.",
  signupErrorsEmailPattern: "Veuillez entrer un email valide.",
  signupErrorsPasswordRequired: "Le mot de passe est requis.",
  signupErrorsPasswordMinLength: "Minimum 8 caractères requis.",
  signupErrorsPasswordMaxLength: "Maximum 16 caractères autorisés.",
  signupErrorsPasswordPattern:
    "Doit contenir entre 8 et 16 caractères, incluant des lettres majuscules et minuscules, des chiffres et un caractère spécial (ex. : NextGen@123)",
  otpIsRequired: "Le code OTP est requis",
  otpMustBeSixDigits: "Le code OTP doit comporter 6 chiffres",
  enterOtp: "Entrez le code OTP",
  accountMenuTransactions: "Transactions",
  accountMenuPromotions: "Promotions",
  accountMenuProfile: "Profil",
  accountMenuLogout: "Déconnexion",
  accountMenuWithdraw: "Retirer",
  pageNotFound: "Nous ne pouvons pas trouver la page que vous recherchez !",
  error: "Erreur",
  somethingWentWrong: "Une erreur est survenue !",
  verifyEmailThankYou: "Merci !",
  verifyEmailEmailIsVerified: "Votre email est vérifié.",
  verifyEmailWentWrong: "Une erreur est survenue !",
  verifyEmailTokenExpired: "Email déjà vérifié ou lien expiré",
  create: "Créer",
  profilePassword: "Mot de passe",
  profileUploadProfile: "Téléverser une photo",
  profileErrorsEmailRequired: "L'email est requis.",
  profileErrorsEmailPattern: "Veuillez entrer un email valide.",
  profileErrorsEmailMinLength: "Minimum 3 caractères requis.",
  profileErrorsEmailMaxLength: "Maximum 20 caractères autorisés.",
  profileMessagesProfileUpdate: "Profil mis à jour",
  profileMessagesChangePassword: "Mot de passe mis à jour",
  profileProfilePicProfilePicUpload: "Téléverser l'image du profil",
  profileNoNewChanges:
    "Impossible de mettre à jour le profil ! Aucune modification.",
  profileLoggedInWithSocial: "Vous vous êtes connecté via un compte social.",
  profileSideNavigatorSound: "Son",
  profileSideNavigatorMusic: "Musique",
  profileSideNavigatorProfile: "Mon profil",
  profileSideNavigatorBetHistory: "Historique des paris",
  profileSideNavigatorTransactions: "Transactions",
  profileSideNavigatorDeposit: "Dépôt",
  withdraw: "Retirer",
  profileSideNavigatorGameLimits: "Limites de jeu",
  profileSideNavigatorReferral: "Parrainage",
  profileSideNavigatorChangePassword: "Changer le mot de passe",
  profileSideNavigatorTermsConditions: "Termes et conditions",
  profileSideNavigatorLogOut: "Déconnexion",
  profileSideNavigatorProvablyFair: "Provably Fair",
  WalletInfoSectionNotAvailable: "Non disponible",
  WalletInfoSectionRealBalance: "Solde réel",
  GameLimitsMinimumBet: "Mise minimale",
  GameLimitsMaximumBet: "Mise maximale",
  GameLimitsMaxWinFor1Bet: "Gain maximal pour un pari",
  ProvablyFairSubTitle:
    "Ce jeu utilise la technologie Provably Fair pour déterminer le résultat. Cet outil vous permet de changer votre seed et de vérifier l'équité du jeu.",
  ProvablyFairMaximumBet: "Mise maximale :",
  ProvablyFairMaxWinFor1Bet: "Gain maximal pour un pari",
  promotionsTitle: "Promotions",
  promotionsNoLosingData:
    "Désolé, aucune promotion de bonus perdant disponible pour ",
  promotionsNoDepositData:
    "Désolé, aucune promotion de bonus dépôt disponible pour ",
  promotionsCurrency: " devise.",
  promotionsViewBtn: "Voir",
  promotionsClaimSuccess: "Vous avez réclamé avec succès",
  promotionsAvailability: "Disponibilité : ",
  promotionsAvailabilityTabLosing: "Bonus perdant",
  promotionsAvailabilityTabDeposit: "Bonus dépôt",
  promotionsDepositBonusTableCode: "Code",
  promotionsDepositBonusTableMinDeposit: "Dépôt min.",
  promotionsDepositBonusTablePercentage: "Pourcentage",
  promotionsDepositBonusTableMaxBonus: "Bonus max.",
  promotionsDepositBonusTableRolloverMultipler: "Multiplicateur de rollover",
  promotionsDepositBonusTableMaxRolloverPerBet: "Rollover max par pari",
  promotionsDepositBonusTableTimeToAchieveRolloverTarget:
    "Temps pour atteindre l'objectif de rollover",
  promotionsBonusCode: "CODE BONUS : ",
  promotionsLossesClaim:
    "Les pertes peuvent être réclamées (pendant la période de la campagne) : ",
  promotionsLossesClaimLosingBonusTablePercentage: "Pourcentage",
  promotionsLossesClaimLosingBonusTableMinLosingAmount: "Montant minimum perdu",
  promotionsBonusStatus: "Statut du bonus : ",
  promotionsBonusAmount: "Montant du bonus : ",
  promotionsRolloverTarget: "Objectif de rollover : ",
  promotionsRolloverAchieved: "Rollover atteint : ",
  promotionsActivatebtn: "ACTIVER",
  promotionsClaimBtn: "RÉCLAMER",
  promotionsCancelBtn: "ANNULER",
  promotionsBackBtn: "RETOUR",
  promotionsBonus: "Bonus",
  promotionsTermAndConditions: " Termes et conditions",
  promotionsClaimDepositBonusTitle: "Étapes pour réclamer le bonus dépôt",
  promotionsClaimDepositBonusFirst: "Activer le code bonus",
  promotionsClaimDepositBonusSecond: "Déposer le montant sur le portefeuille",
  promotionsClaimDepositBonusThird:
    "Atteindre l'objectif de rollover pour réclamer le bonus",
  promotionsClaimLosingBonusTitle: "Étapes pour réclamer le bonus perdant",
  promotionsClaimLosingBonusFirst: "Activer le code bonus",
  promotionsClaimLosingBonusSecond: "Jouez à vos jeux préférés",
  promotionsClaimLosingBonusThird:
    "Cliquez sur 'Réclamer les pertes' pour réclamer les pertes pendant la période de la campagne",
  promotionsWentWrong: "Une erreur est survenue !",
  transactionTitle: "Transactions",
  transactionBetId: "ID du pari",
  transactionUser: "Utilisateur",
  transactionPayout: "Paiement",
  transactionAmount: "Montant",
  transactionTime: "Date",
  transactionProfit: "Profit",
  transactionCashout: "Encaisser",
  transactionBet: "Pari",
  transactionMultix: "Multiplicateur",
  transactionWin: "Gain",
  transactionFairness: "Équité",
  transactionReferFriend: "Parrainer un ami",
  transactionTotal: "Total des paris",
  transactionWins: "Gains",
  transactionRefresh: "Rafraîchir",
  transactionFilterTopMultipliers: "Top multiplicateurs",
  transactionFilterHugeWins: "Gros gains",
  transactionFilterBiggestWins: "Plus gros gains",
  transactionFilterMultipliers: "Multiplicateurs",
  transactionRealBalance: "Solde réel",
  depositWithdrawTXDate: "Date",
  depositWithdrawTXAmount: "Montant",
  depositWithdrawTXTxId: "ID Tx",
  depositWithdrawTXTxType: "Type de transaction",
  depositWithdrawTXStatus: "Statut",
  depositWithdrawTXNoData: "Aucune donnée disponible.",
  depositTitle: "Dépôt",
  depositHistory: "Historique",
  depositSubTitle:
    "L'utilisateur ne peut pas déposer ou retirer de la monnaie fiduciaire. Veuillez contacter l'administrateur pour effectuer des transactions en monnaie fiduciaire.",
  depositCopyNotSupported:
    "Votre navigateur ne prend pas en charge la copie automatique dans le presse-papiers.\nVeuillez copier le code manuellement.",
  depositCopied: "Adresse copiée.",
  withdrawNoBalance: "Solde insuffisant.",
  withdrawMinAmount: "Veuillez entrer un montant supérieur ou égal à {{min}}.",
  paginationNextBtn: "Suivant",
  paginationPrevBtn: "Précédent",
  LoginRequired: "Connexion requise !",
  betPlacedSuccessfully: "Pari placé",
  betCancelledSuccessfully: "Pari annulé avec succès",
  PlayerEscapedSuccessfully: "Joueur sorti",
  CopiedSuccessfull: "Copié avec succès",
  usersConsent:
    "En accédant à ce site, je confirme avoir 18 ans et avoir lu, \n compris et consenti aux",
  termsOfService: "Conditions d'utilisation",
  email: "Email",
  playNow: "Jouer maintenant",
  orContinueWith: "Ou continuer avec",
  metamaskExtensionNotAvailable:
    "Veuillez installer l'extension MetaMask et actualiser la page.",
  cashier: "DÉPÔT",
  account: "COMPTE",
  hello: "Bonjour",
  balance: "Solde",
  referrals: "Parrainages",
  settings: "Paramètres",
  withdrawals: "Retraits",
  demoWallet: "Portefeuille Démo",
  wallet: "Portefeuille",
  user: "Utilisateur",
  amountIsRequired: "Le montant est requis",
  minDepositAmount: "Le dépôt doit être supérieur à {{min}}.",
  maxDepositAmount: "Le dépôt doit être inférieur à {{max}}.",
  minWithdrawAmount: "Doit être supérieur à {{min}}",
  withdrawMustLessThanWallet:
    "Le retrait doit être inférieur au solde du portefeuille",
  accountTypeIsRequired: "Le type de compte est requis.",
  mobileNumberLength:
    "Le numéro de téléphone doit comporter {{length}} chiffres",
  phoneIsRequired: "Le téléphone est requis",
  cpfError: "Le CPF doit comporter {{length}} caractères",
  cpfRequiredError: "Le CPF est requis",
  cnpjError: "Le CNPJ doit comporter {{length}} caractères",
  mainMenu: "MENU PRINCIPAL",
  casino: "Casino",
  sports: "Sports",
  crypto: "Crypto",
  NextGenXp: "NextGen XP",
  playEarn: "Jouer & Gagner",
  NFT: "NFT",
  poker: "Poker",
  earnRewards: "GAGNER DES RÉCOMPENSES",
  rankUp: "Monter en grade",
  inviteFriends: "Inviter des amis",
  affiliates: "Affiliés",
  sportsbook: "Book de sport",
  menu: "Menu",
  allBets: "Tous les paris",
  highRollers: "Grands joueurs",
  luckyBets: "Paris chanceux",
  trade: "Trade",
  player: "JOUEUR",
  time: "TEMPS",
  wager: "MISE",
  payoutText: "PAIEMENT",
  bannerHeadOne: "Découvrez la véritable innovation avec le plus haut",
  bannerHeadTwo: "programme de récompenses de l'industrie.",
  registerNow: "Inscrivez-vous maintenant",
  copy: "Copier",
  liveWins: "GAINS EN DIRECT",
  monthlyStatus: "M",
  weeklyStatus: "S",
  dailyStatus: "J",
  nextEcosystem: "Écosystème NextGen",
  allGames: "Tous les jeux",
  allSports: "Tous les sports",
  cryptoFutures: "Futures crypto",
  tradeNow: "Trader maintenant",
  allTables: "Toutes les tables",
  nft: "NFT",
  viewAll: "Tout voir",
  rewards: "Récompenses",
  profile: "Profil",
  nextgenProfile: "PROFIL NEXTGEN",
  totalBets: "Total des paris",
  totalWagered: "Total misé",
  joinDate: "Date d'inscription",
  displaySocialLinks: "Afficher les comptes sociaux liés",
  privateProfile: "Profil privé",
  rank: "Rang",
  nextRank: "Rang suivant",
  changeUsername: "Changer le nom d'utilisateur",
  newPassword: "Nouveau mot de passe",
  repeatNewPassword: "Répéter le nouveau mot de passe",
  changeName: "Changer le nom",
  linkSocialAccount: "Lier un compte social",
  privateProfileTooltip:
    "Une fois votre profil défini comme privé, les autres utilisateurs ne pourront pas voir vos activités de mise, vos récompenses ou vos liens sociaux",
  socialLinksTooltip:
    "Liez vos comptes sociaux pour permettre aux autres utilisateurs de vous suivre.",
  balances: "Soldes",
  createReferralBalance: "Créer un solde de parrainage",
  total: "Total",
  tips: "Conseils",
  receivedAmount: "Montant reçu",
  dateOrTime: "Date/Heure",
  view: "Voir",
  allChains: "Toutes les chaînes",
  creditAmount: "Montant crédité",
  setCustomReferralLink: "Définir un lien de parrainage personnalisé",
  changeEmail: "Changer l'email",
  newEmail: "Nouvel email",
  newUsername: "Nouveau nom d'utilisateur",
  username: "Nom d'utilisateur",
  changePassword: "Changer le mot de passe",
  twoFactorAuthentication: "Authentification à deux facteurs",
  twoFactorAuthenticationTitle:
    "L'utilisation de l'authentification à deux facteurs est fortement recommandée car elle protège votre compte avec votre mot de passe et votre téléphone. Un email et un mot de passe doivent être définis pour activer la 2FA. Tant que la 2FA est activée, vous ne pourrez pas vous connecter via Steam.",
  enable2fa: "Activer la 2FA",
  verifyIdentityByKyc: "Vérifiez votre identité (KYC)",
  oldPassword: "Ancien mot de passe",
  live: "En direct",
  soccer: "Football",
  tennis: "Tennis",
  fifa: "Fifa",
  basketball: "Basket-ball",
  iceHockey: "Hockey sur glace",
  volleyball: "Volley-ball",
  tableTennis: "Tennis de table",
  baseball: "Base-ball",
  golf: "Golf",
  boxing: "Boxe",
  myBets: "Mes paris",
  favourites: "Favoris",
  americanFootball: "Football américain",
  buyCrypto: "Acheter des cryptos",
  oldEmail: "Ancien email",
  loggedInSuccess: "Connexion réussie",
  loggedOutSuccess: "Déconnexion réussie",
  signup: "Inscription terminée",
  tokenVerify: "Jeton de vérification envoyé à votre email. Veuillez vérifier.",
  emailVerify: "Email vérifié",
  emailChangedSuccess: "Email mis à jour",
  emailUpdateOtp: "OTP envoyé au nouvel email",
  profileUpdatedSuccess: "Profil mis à jour",
  otpVerified: "Mot de passe à usage unique (OTP) vérifié",
  twoFADeactivated: "Authentification à deux facteurs désactivée",
  internalServerError: "Erreur interne du serveur",
  unAuthorized: "Non autorisé",
  dataNotFound: "Données non trouvées",
  setReferralLink: "Définir le lien de parrainage...",
  notFound: "Non trouvé",
  nextgenOriginals: "Meilleurs jeux",
  status: "Statut",
  success: "Succès",
  failed: "Échoué",
  pending: "En attente",
  date: "Date",
  to: "À",
  roundId: "ID du tour",
  bet: "Pari",
  win: "Gain",
  at: "à",
  downloadAll: "Tout télécharger",
  gameText: "Jeu",
  searchGames: "Rechercher des jeux",
  provider: "Fournisseur",
  search: "Rechercher",
  all: "Tous",
  sortBy: "Trier par",
  popular: "Populaire",
  loadMore: "Charger plus",
  bitcoin: "Bitcoin",
  btc: "BTC",
  chat: "Chat",
  loginToChat: "Connectez-vous pour discuter",
  send: "Envoyer",
  expand: "Développer",
  collapse: "Réduire",
  emailPlaceholder: "votremail@domaine.com",
  removeFromFavourite: "Retirer des favoris",
  addToFavourite: "Ajouter aux favoris",
  verify: "Vérifier",
  accountVerification: "Vérification du compte",
  recentlyPlayed: "Récemment joué",
  moreFrom: "Plus de",
  demoMode: "Mode démo",
  providersList: "Liste des fournisseurs",
  games: "Jeux",
  providers: "Fournisseurs",
  close: "Fermer",
  joinedOn: "Inscrit le",
  rewarded: "Récompensé",
  saySomething: "Dites quelque chose",
  addressIsRequired: "L'adresse est requise",
  withdrawRequestSent: "Demande de retrait soumise. En attente d'approbation.",
  noMatchesFound: "Aucun résultat trouvé",
  tip: "Pourboire",
  sendTip: "Envoyer un pourboire",
  minAmount: "Le montant doit être supérieur à {{min}}",
  maxAmount: "Le montant doit être inférieur à {{max}}",
  doNotShowTip: "Ne pas afficher le pourboire dans le chat",
  demoAvailable: "Démo disponible",
  denoNotAvailable: "Démo non disponible",
  goFullscreen: "Passer en plein écran",
  endsAt: "Se termine à",
  inProgress: "En cours",
  eventEnd: "Fin de l'événement",
  latestPromotions: "Dernières promotions",
  archived: "Archivé",
  noPromotionsFound: "Aucune promotion trouvée",
  claim: "Réclamer",
  add: "Ajouter",
  viewDashboard: "Voir le tableau de bord",
  prize: "Prix",
  timeLeft: "Temps restant",
  viewTransactions: "Voir les transactions",
  sendAmountInCashier:
    "Envoyez le montant de {{- currency}} de votre choix à l'adresse suivante pour recevoir l'équivalent en Coins.",
  yourPersonalDepositAddress:
    "Votre adresse de dépôt personnelle {{- currency}}",
  copyAddress: "Copier l'adresse",
  theValueOfCurrencyMayChange:
    "La valeur de {{- currency}} peut changer entre maintenant et le moment où nous recevons votre paiement",
  doNotHaveAnyCurrency: "Vous n'avez pas de {{- currency}} ?",
  depositOptions: "Options de dépôt",
  withdrawalOptions: "Options de retrait",
  withdrawCurrency: "Retirer {{- currency}}",
  enterAddressToReceiveFunds:
    "Veuillez entrer l'adresse du portefeuille {{- currency}} sur laquelle vous souhaitez recevoir les fonds. Une fois confirmé, le retrait est généralement traité en quelques minutes.",
  receivingCurrencyAddress: "Adresse de réception {{- currency}}",
  withdrawalAmount: "Montant du retrait",
  pasteYourCurrencyAddressHere:
    "Collez votre adresse de portefeuille {{- currency}} ici...",
  request: "Demander",
  receiveTheSpecifiedAmount:
    "*Vous recevrez le montant spécifié en {{- currency}} sur votre adresse de retrait",
  valueMayVary:
    "*La valeur soustraite de votre solde peut varier entre maintenant et le moment où nous traitons votre retrait",
  coupons: "Coupons",
  updateEmail: "Mettre à jour l'email",
  update: "Mettre à jour",
  loginHistory: "Historique de connexion",
  showLoginHistory: "Afficher l'historique de connexion",
  wagerErr: "Le montant de la mise est requis",
  minWagerErr: "Le montant minimum de mise est de 1",
  mulValErr: "La valeur du multiplicateur doit être comprise entre 1 et 1000",
  closeBetErr: "Entrez un montant de pari valide",
  profitErr: "Entrez un montant de prise de profit valide",
  multiplierErr: "Le montant du multiplicateur est requis",
  manual: "Manuel",
  auto: "Automatique",
  pnLFee: "Frais PnL",
  flatFee: "Frais fixes",
  takeProfitLabel: "PRENDRE LE PROFIT AU PRIX",
  closeBetLabel: "FERMER LE PARI AU PRIX",
  priceUpLabel: "LE PRIX VA-T-IL AUGMENTER OU BAISSER ?",
  up: "Haut",
  down: "Bas",
  payoutMul: "MULTIPLICATEUR DE PAIEMENT",
  safe: "Sûr",
  wild: "Wild",
  placeBet: "Placer le pari",
  roundEnd: "LE TOUR SE TERMINE DANS",
  timerInfo:
    "Tous les paris Rollercoaster seront clôturés et le prix sera réinitialisé à 1 000 $ chaque jour à 00:00 UTC",
  month: "mois",
  PNL: "P&L",
  ROI: "ROI",
  roi: "roi",
  funding: "Financement/H",
  exitPriceLabel: "Prix de sortie",
  cashedOut: "Encaissement effectué",
  open: "Ouvert",
  chartPreferences: "Préférences du graphique",
  yAxis: "Préférences de l'axe Y",
  additionalFeatures: "Fonctionnalités supplémentaires",
  themes: "Thèmes",
  locale: "Langue",
  changeTimezone: "Changer de fuseau horaire",
  changeLanguage: "Changer de langue",
  tooltip: "Info-bulle",
  field: "Champ",
  value: "Valeur",
  dateTime: "Date/Heure",
  winningAmount: "Montant gagné",
  activeBets: "Paris actifs",
  closedBets: "Paris fermés",
  publicBets: "Paris publics",
  leaderboard: "Classement",
  howToPlay: "Comment jouer",
  rOICalculator: "Calculateur ROI",
  allInstruments: "Tous les instruments",
  week: "Semaine",
  monthLabel: "Mois",
  day: "Jour",
  betLabel: "PARI",
  entryPrice: "PRIX D'ENTRÉE",
  bustPriceLabel: "Prix de rupture",
  multiplierLabel: "MULTIPLICATEUR",
  exitPrice: "PRIX DE SORTIE",
  pnl: "P&L",
  details: "Voir les détails",
  profitLoss: "Profit & Perte",
  noBalance: "Solde insuffisant.",
  maxBetAmount: "Montant maximum du pari",
  limit: "limite dépassée.",
  minBetAmount: "Montant minimum du pari",
  rollsLimitMsg: "Le nombre de rouleaux doit être inférieur ou égal à 100.",
  mines: "Mines",
  loginFailed: "Échec de la connexion",
  noEntries: "Aucune entrée",
  descriptionIsRequired: "La description est requise",
  description: "Description",
  report: "Signaler",
  userReportedSuccessfully: "Utilisateur signalé",
  tipSendSuccessfully: "Pourboire envoyé",
  walletSettings: "Paramètres du portefeuille",
  hideZero: "Masquer les soldes nuls",
  hideZeroInfo: "Votre solde nul n'apparaîtra pas dans votre portefeuille",
  displayFiat: "Afficher le crypto en fiat",
  displayFiatInfo:
    "Tous les paris et transactions seront réglés en équivalent crypto",
  noteForApprox: "Veuillez noter qu'il s'agit d'approximations de devises.",
  save: "Enregistrer",
  limits: "Limites",
  wagerLimit: "Limite de mise",
  lossLimit: "Limite de perte",
  depositLimit: "Limite de dépôt",
  takeABreak: "Faites une pause",
  customTimePeriod: "Période personnalisée",
  timePeriod: "Période",
  selfExclusion: "Auto-exclusion",
  confirm: "Confirmer",
  setLimit: "Définir la limite",
  removeLimit: "Supprimer la limite",
  enterAmount: "Entrer le montant",
  hours: "Heures",
  daily: "Quotidien",
  weekly: "Hebdomadaire",
  monthly: "Mensuel",
  cancel: "Annuler",
  usedLimit: "Limite utilisée",
  type: "Type",
  updatedAt: "Mis à jour le",
  editLimit: "Modifier la limite",
  limitRemovedMessage: "La limite suivante sera supprimée.",
  setLimitMessage:
    "Vous êtes sur le point de définir la limite suivante pour votre compte. Notez que si vous souhaitez changer la limite, vous pourrez le faire après 24h.",
  setBreakMessage:
    "Vous êtes sur le point de bloquer l'accès à votre compte pour une période prédéfinie. Une fois utilisé, vous ne pourrez plus vous connecter pour modifier la période de blocage. Pour choisir une période différente ou prolonger l'existante, veuillez contacter le support en direct.",
  setSessionLimitMessage:
    "Vous êtes sur le point de définir la limite suivante pour votre compte. Notez que pour modifier cette limite, il faudra 24 heures après avoir défini un nouveau montant.",
  removeSessionLimitMessage: "Votre limite de session sera supprimée",
  notAchieved: "non atteinte",
  flexibleRegistration: "Inscription flexible !",
  mostPlayed: "Les plus joués",
  badge: "Badges",
  allBadges: "Tous les badges",
  socialMedia: "Réseaux sociaux",
  allLinks: "Tous les liens",
  statistics: "Statistiques",
  newMessage: "Nouveau message",
  tipFor: "pourboire pour",
  play: "Jouer",
  betOn: "Parier sur",
  liveCasino: "Casino en direct",
  ecosystemUnbeatableOdds:
    "Pariez mieux - Accédez à des cotes imbattables sur des événements passionnants avec notre plateforme de paris de premier ordre !",
  startBetting: "Commencez à parier",
  ecosystemJoinTheFun:
    "Rejoignez le plaisir - Découvrez les jeux exclusifs de NextGen et plus de 9 000 favoris du casino !",
  futures: "Futures",
  ecosystemTrade:
    "NGB est votre passerelle de confiance vers l'avenir des jeux et paris en ligne immersifs !",
  ecosystemCasino24x7:
    "Vivez le frisson du jeu en temps réel avec des croupiers professionnels à tout moment. Plongez dans l'action non-stop !",
  joinNow: "Rejoignez maintenant",
  noNotificationsFound: "Aucune notification trouvée",
  notifications: "Notifications",
  lobby: "Lobby",
  rollercoaster: "NextGen Coaster",
  applyReferralCode: "Appliquer le code de parrainage",
  referralCode: "Code de parrainage",
  referralLink: "Lien de parrainage",
  copyLink: "Copier le lien",
  referralLinkCopied: "Lien de parrainage copié",
  withdrawAddressCannotBeSame:
    "L'adresse de retrait ne peut pas être la même que la vôtre",
  userId: "ID utilisateur",
  active: "Actif",
  inactive: "Inactif",
  currency: "Devise",
  hostGames: "Hébergez des jeux,",
  earnCrypto: "Gagnez des crypto-monnaies",
  inviteHostAndEarn:
    "Invitez, hébergez & gagnez - Organisez vos événements NextGen",
  startEarning: "Commencez à gagner",
  nextGen: "NextGen",
  whitePaper: "Livre blanc",
  deepDiveInto: "Plongez dans l'économie de la NextGen Coin",
  learnMore: "En savoir plus",
  sport: "Sport",
  vipRanked: "Classement VIP",
  betMoreEarnMore: "Pariez plus, gagnez plus - Maximisez votre potentiel",
  expiresAt: "Expire le",
  upload: "Télécharger",
  pleaseSelectImage: "Veuillez sélectionner une image",
  imageSizeMustLessThan:
    "La taille de l'image doit être inférieure à {{size}} Mo",
  imageSizeFormat: "Utilisez le format png, jpeg ou jpg.",
  maxFileSize: "Taille maximale : 2 Mo",
  dragPosition: "Faites glisser pour changer la position",
  onlyNumbers: "Seulement des chiffres",
  cannotBeRemoved: "Ne peut pas être supprimé",
  amountInBetween:
    "Le montant doit être compris entre le quotidien et le mensuel (inclus)",
  amountEqualOrGreater: "Montant égal ou supérieur à l'hebdomadaire",
  amountEqualOrLess:
    "Le montant doit être égal ou inférieur à l'hebdomadaire et au mensuel",
  cannotBeIncreased: "Ne peut pas être augmenté",
  enterPassword: "Entrez le mot de passe",
  sessionLimit: "Limite de session",
  timePeriodRequired: "La période est requise",
  amountGTZero: "Montant supérieur à zéro",
  mma: "MMA",
  counterStrike: "Counter Strike",
  rugbyUnion: "Rugby à XV",
  valorant: "Valorant",
  cricket: "Cricket",
  dota: "DOTA-2",
  rugbyLeague: "Rugby à XIII",
  hilo: "Hilo",
  crash: "Crash",
  cancelBetSuccessfully: "Pari annulé",
  start: "Démarrer",
  invalidBetAmount: "Montant du pari invalide",
  zeroError: "Doit être supérieur à 0",
  flipCoin: "Pile ou face",
  customs: "Douanes",
  redeemCode: "ÉCHANGER LE CODE COUPON",
  couponText: "Nous les publions régulièrement sur notre",
  copyrightText:
    "<aLink>{{website}}</aLink> is owned by {{companyName}}, a Limited Company registered in Cyprus. License Registration Number {{licenseNumber}}.",
  platform: "Plateforme",
  support: "Support",
  faq: "FAQ",
  partnershipProgram: "Programme de partenariat",
  blog: "Blog",
  helpCenter: "Centre d'aide",
  aboutUs: "À propos de nous",
  community: "Communauté",
  facebook: "Facebook",
  twitter: "Twitter",
  instagram: "Instagram",
  discord: "Discord",
  english: "Anglais",
  hindi: "Hindi",
  french: "Français",
  legal: "Juridique",
  cryptoTransactions: "Transactions en crypto",
  sendersName: "Nom de l'expéditeur",
  hideLoginHistory: "Masquer l'historique des connexions",
  loginMethod: "Méthode de connexion",
  deviceType: "Type d'appareil",
  ip: "IP",
  tradingDefinition:
    "Le trading crypto n'est pas du jeu par définition, il n'est donc pas couvert par notre licence de jeu.",
  perks: "Avantages",
  connected: "Connexion établie",
  twitch: "Twitch",
  connect: "Connecter",
  setUpGoogleAuthenticator: "CONFIGURER GOOGLE AUTHENTICATOR",
  twoFACode: "CODE 2FA",
  downloadTheGoogleAuthenticator:
    "1. Téléchargez l'application Google Authenticator pour iPhone ou Android",
  saveTheFollowingAccountToken:
    "2. Enregistrez le jeton de compte (clé) suivant dans un endroit sûr",
  accountTokenKey: "Jeton de compte (clé)",
  scanQRCodeWithApp:
    "3. Scannez le code QR avec l'application Google Authenticator",
  enterTheTokenBelow: "4. Entrez le jeton ci-dessous",
  copied: "Copié",
  code: "Code",
  furtherVerificationRequired: "Vérification supplémentaire requise",
  firstName: "Prénom",
  lastName: "Nom",
  dateOfBirth: "Date de naissance",
  year: "Année",
  addressLine: "Adresse ligne 1",
  addressLineTwo: "Adresse ligne 2",
  city: "Ville",
  province: "Province",
  postalCode: "Code postal",
  country: "Pays",
  submitInformation: "Soumettre les informations",
  level: "Niveau",
  required: "Requis",
  rejected: "Rejeté",
  completed: "Terminé",
  cancelled: "Annulé",
  onHold: "En attente",
  kycRequestSubmittedSuccessfully: "Demande KYC soumise",
  reRequested: "Re-demandé",
  cashBalance: "Solde en espèces",
  bonusBalance: "Solde bonus",
  specialBonus: "Bonus spécial",
  today: "Aujourd'hui",
  noRewards: "Pas de récompenses",
  viewPendingRewards: "Voir les récompenses en attente",
  totalClaimed: "Total réclamé",
  pendingRewards: "Récompenses en attente",
  amount: "Montant",
  others: "Autres",
  createdAt: "Créé le",
  horseRacing: "Courses de chevaux",
  addToHomeScreen: "Ajouter NextGen à l'écran d'accueil",
  oneTabAccess: "Accès en 1 tap sur votre téléphone",
  install: "Installer",
  addToHome: "Ajouter à l'écran d'accueil",
  inChromeSafari: "Dans Chrome/Safari, appuyez sur",
  buttonAndChoose: "le bouton et choisissez",
  afterCompletingThisStep:
    "Après cette étape, accédez à NextGen Bets en un seul tap sur votre téléphone !",
  settlementId: "ID de règlement",
  commission: "Commission",
  totalCommission: "Commission totale",
  commissionSettlement: "Règlement des commissions",
  startplaying: "Commencez à jouer",
  forgotPassword: "Mot de passe oublié",
  resetPassword: "Réinitialiser le mot de passe",
  locked: "Verrouillé",
  unlocked: "Déverrouillé",
  yourRank: "Votre rang",
  nextRanks: "Rangs suivants",
  allRanks: "Tous les rangs",
  bonusClaimedSuccessfully: "Bonus réclamé",
  passwordUpdated: "Mot de passe mis à jour !",
  thatsOkayItHappens:
    "Ce n'est pas grave. Cela arrive. Cliquez sur le bouton ci-dessous pour continuer. Email",
  passwordsMustMatch: "Les mots de passe doivent correspondre",
  youNearlyThere: "Vous y êtes presque !",
  weSendYouVerificationEmail:
    "Nous vous avons envoyé un email de vérification. Veuillez vérifier votre email et confirmer votre compte.",
  verifyEmailAddress: "Vérifiez votre adresse email",
  pleaseNoteThatTheLinkWillExpire:
    "Veuillez noter que ce lien expirera dans 5 jours. Si vous ne vous êtes pas inscrit sur NextGen Bets, ignorez cet email. Merci",
  autoBetStops:
    "Les paris automatiques s'arrêtent en raison du dépassement de la limite de mise",
  casinoBets: "Paris casino",
  sportsBet: "Paris sportifs",
  cryptoTrades: "Trades crypto",
  customBets: "Paris personnalisés",
  nothingFound: "Rien trouvé",
  bonus: "Bonus",
  claimedAt: "Réclamé le",
  available: "Disponible",
  previous: "Précédent",
  next: "Suivant",
  tooManyRequests: "Trop de requêtes.",
  limitUpdatedSuccessFully: "Limite mise à jour",
  youLost: "Vous avez perdu",
  cashOutFailed: "Retrait échoué",
  betAlreadyPlaced: "Pari déjà placé",
  betCashedOut: "Pari retiré",
  noFavouritesIn: "Pas de favoris dans",
  team: "Équipe NextGen",
  fiatAmount: "Montant en fiat",
  cryptoAmount: "Montant crypto",
  moonpay: "Moonpay",
  paymentMethod: "Méthode de paiement",
  transactionId: "ID de transaction",
  address: "Adresse",
  comingSoon: "Bientôt disponible !",
  minOneCharacterRequired: "Au moins un caractère requis",
  verifyOtp: "Vérifier OTP",
  noResults: "Aucun résultat",
  moreFromBrand: "Plus de NextGen Bets",
  cryptoDeposit: "Dépôt crypto",
  cryptoWithdraw: "Retrait crypto",
  fiatDeposit: "Dépôt fiat",
  fiatWithdraw: "Retrait fiat",
  goToPaymentsPage: "Aller à la page des paiements.",
  bankTransfer: "Virement bancaire",
  initiateTransfer: "Initier le virement",
  emt: "EMT",
  initiateEmt: "Initier EMT",
  checkYourMailForFurtherDetails: "Vérifiez votre email pour plus de détails",
  gigadet: "Gigadet",
  wallet88: "Wallet88",
  select_language: "Sélectionner la langue",
  raise_a_ticket: "Soumettre une demande",
};
